"use client";
import React from "react";
import { PDFViewer } from "./../pDFViewer";
import type { PdfViewerDynamicProps } from './../../../interfaces'

/**
 * Thin wrapper kept for API compatibility. It used to pre-fetch
 * /pdfs/<baseId>/info.json and hard-error when absent; PDFViewer now performs
 * that same-origin fetch itself and degrades gracefully when the file is
 * missing, so this simply delegates.
 */
const PdfViewerDynamic: React.FC<PdfViewerDynamicProps> = (Props) => {
  return <PDFViewer baseId={Props.baseId} />;
};

export default PdfViewerDynamic;
